import {
  POSTHOG_BROWSER_INIT_DEFAULTS,
  resolvePosthogPublicConfig,
} from '@up2stay/up2promo-commons/analytics';
import posthog from 'posthog-js';

import { env } from './env';

let initialized = false;

function resolveConfig() {
  return resolvePosthogPublicConfig({
    key: env.VITE_POSTHOG_KEY,
    host: env.VITE_POSTHOG_HOST,
  });
}

export function initPosthog(): void {
  if (typeof window === 'undefined' || initialized) return;

  const config = resolveConfig();
  if (!config.enabled || !config.key) return;

  posthog.init(config.key, {
    api_host: config.host,
    ...POSTHOG_BROWSER_INIT_DEFAULTS,
  });

  posthog.register({
    app: 'up2promo-setup',
  });

  initialized = true;
}

export function getPosthog() {
  return posthog;
}

export function captureEvent(
  event: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function captureException(
  error: unknown,
  extra?: Record<string, unknown>,
): void {
  if (!initialized) return;
  if (error instanceof Error) {
    posthog.captureException(error, extra);
    return;
  }
  posthog.capture('$exception', {
    ...extra,
    message: String(error),
  });
}
